function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import merge from 'lodash/merge';

export function isString(s) {
  return Object.prototype.toString.call(s) === '[object String]';
}

export function isObject(s) {
  return Object.prototype.toString.call(s) === '[object Object]';
}

export function isArray(s) {
  return Object.prototype.toString.call(s) === '[object Array]';
}

export function isNumber(s) {
  return Object.prototype.toString.call(s) === '[object Number]';
}

function isFunction(s) {
  return Object.prototype.toString.call(s) === '[object Function]';
}

export function evaluateBuilder(builder) {
  if (builder instanceof Promise) {
    return builder.then(function (r) {
      return evaluateBuilder(r);
    });
  } else if (isArray(builder)) {
    return Promise.all(builder.map(evaluateBuilder));
  } else if (isFunction(builder)) {
    return evaluateBuilder(Promise.resolve(builder()));
  } else if (isObject(builder)) {
    var keys = Object.getOwnPropertyNames(builder);
    var results = keys.reduce(function (accl, key) {
      var node = builder[key];
      if (isObject(node) || isFunction(node) || node instanceof Promise) {
        return accl.concat(evaluateBuilder(node));
      }
      return accl.concat([new Promise(function (r) {
        return r(node);
      })]);
    }, []);

    return Promise.all(results).then(function (resolvedResults) {
      return resolvedResults.reduce(function (accl, res, index) {
        return merge(accl, _defineProperty({}, keys[index], res));
      }, {});
    });
  }

  return new Promise(function (r) {
    return r(builder);
  });
}

export function evaluateAndFlatten(builder) {
  if (isArray(builder)) {
    return Promise.all(builder.map(function (b) {
      return evaluateBuilder(b);
    })).then(function (results) {
      return merge.apply(undefined, [{}].concat(_toConsumableArray(results.filter(isObject))));
    });
  }
  return evaluateBuilder(builder);
}

/**
 * Function for getting device type taken from the old SDK. It performs as well
 * as one could expect from the size. It could be replaced with 'ua-parser-js'
 * at the cost of 11kb minimized.
 *
 * @param {string} userAgent
 *
 * @returns {string} the device type the user is using
 */
export function deviceType(userAgent) {
  var knownDevices = {
    mobile: ['iPhone;', 'iPod;', 'iPod touch;', '^HTC', 'Fennec', 'IEMobile', 'BB10;', 'BlackBerry', 'SymbianOS.*AppleWebKit', '^Mozilla.*Mobile.*Firefox', '^Mozilla.*Chrome.*Mobile', 'Opera Mobi', 'Android.*Mobile', 'Android.*Mini', 'Symbian', '^SonyEricsson', '^Nokia', '^SAMSUNG', '^LG'],
    tablet: ['iPad;', 'Android']
  };

  function isDeviceIn(object) {
    var regex = void 0;
    for (var i = 0; i < object.length; i += 1) {
      regex = object[i];
      if (userAgent.match(new RegExp(regex))) {
        return true;
      }
    }
    return false;
  }

  if (userAgent) {
    if (isDeviceIn(knownDevices.mobile)) {
      return 'mobile';
    }
    if (isDeviceIn(knownDevices.tablet)) {
      return 'tablet';
    }
  }
  return 'desktop';
}

export function dateTime() {
  return new Date().toISOString();
}